/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Processing Rule Params";
const frontMatter = {};
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return <_components.p>{"Use the parameters in this section to configure this processing rule. The\nTelemetry Pipeline web interface uses the items in the "}<_components.strong>{"Name"}</_components.strong>{" column to\ndescribe these parameters. "}<_components.a href="/pipeline-configure/config-files">{"Pipeline configuration files"}</_components.a>{"\nuse the items in the "}<_components.strong>{"Key"}</_components.strong>{" column as YAML keys."}</_components.p>;
}

export default MDXLayout